import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ListOrdered } from "lucide-react";
import { toast } from "sonner";
import { api, fetchConfig, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppHeader, PageShell } from "@/components/AppHeader";
import { GameDayView } from "@/components/gameday/GameDayView";
import { GameDayPicker } from "@/components/gameday/GameDayPicker";

export default function GameDayPage() {
  const { teamId } = useParams();
  const { user } = useAuth();
  const [config, setConfig] = useState(null);
  const [team, setTeam] = useState(null);
  const [gd, setGd] = useState(null);
  const [picking, setPicking] = useState(false);

  useEffect(() => {
    fetchConfig().then(setConfig);
    api.team(teamId).then(setTeam);
    api.gameday(teamId).then(setGd);
  }, [teamId]);

  const save = async (keys) => {
    try {
      setGd(await api.setGameday(teamId, keys));
      setPicking(false);
      toast.success("Game day list saved");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (!config || !team || !gd) return <div className="min-h-screen grid place-items-center font-heading text-2xl">Loading game day...</div>;
  return (
    <PageShell>
      <AppHeader>
        <Link to={`/coach/teams/${teamId}`} className="nav-btn" data-testid="gameday-back-link"><ArrowLeft size={18} /> Playbook</Link>
      </AppHeader>
      <div className="team-banner">
        <div className="min-w-0">
          <p className="ctl-label">Game day · coaches only</p>
          <h1 className="font-heading text-2xl sm:text-4xl font-extrabold uppercase tracking-tight truncate" data-testid="gameday-team-name">{team.name}</h1>
        </div>
        {user.access.has_access && (
          <button className="btn-ghost" data-testid="gameday-pick-button" onClick={() => setPicking(true)}><ListOrdered size={18} /> Pick & order</button>
        )}
      </div>
      <GameDayView cfg={config.sports[team.sport][team.level]} plays={gd.selected} />
      {picking && <GameDayPicker open onOpenChange={setPicking} selected={gd.selected} candidates={gd.candidates} onSave={save} />}
    </PageShell>
  );
}
